import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import categoryService from "../../../../api/Category/CategoryService";
export default class CreateCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
      category: { id: null, name: null, ar_name: null },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  onFileSelect = (e) => {
    this.setState({ file: e.target.files[0] });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (name, e) => {
    let category = this.state.category;
    category[name] = e.target.value;
    this.setState({ category });
  };

  onButtonClick = () => {
    const formData = new FormData();
    formData.append("document", this.state.file);
    formData.append("name", this.state.category.name);
    formData.append("ar_name", this.state.category.ar_name);
    categoryService.addCategory(formData);
    toast.success(`Category Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({ category: { id: null, name: null } });
    document.getElementById("img").value = "";
    document.getElementById("name").value = "";
    document.getElementById("ar_name").value = "";
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Category</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="img" id="create-user">
              <FormControl
                autoFocus
                type="file"
                name="img"
                id="img"
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Category Name</label>
              <FormControl
                autoFocus
                type="text"
                name="name"
                id="name"
                onChange={(e) => this.onCreateChange("name", e)}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Category Name</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_name"
                id="ar_name"
                onChange={(e) => this.onCreateChange("ar_name", e)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
